// parseSpikeData.js

// fix: compute relativeTime from spike offset and chunk timestamp
export function parseSpikeData(json, setSpikeBuffer) {
  const SAFE_SPIKE_BUFFER_SIZE = 1000; // generous margin
  const spikeEntries = json.data.filter(entry => entry.spikes?.length > 0);

  spikeEntries.forEach(entry => {
    const { timestamp, experimentStartTime, neuron_id, phase } = entry;

    entry.spikes.forEach(spikeOffset => {
      const spikeTimestamp = timestamp + spikeOffset;
      const point = {
        timestamp: spikeTimestamp * 1000, // for chart.js
        relativeTime: spikeTimestamp - experimentStartTime,
        neuron_id,
        phase,
      };

      // Limit spikeBuffer to last N points to prevent memory growth.
      // Must be large enough to retain all spikes from current chunk until binned.
      // Bin counts are preserved separately in spikeCountBuffer.
      setSpikeBuffer(prev => [...prev, point].slice(-SAFE_SPIKE_BUFFER_SIZE));
    });
  });
}